module.exports = __webpack_public_path__ + "static/media/yantralive-new-banner3.da565195.png";